export default "__VITE_PUBLIC_ASSET__379ed6d9__"